import { requestService as api } from "../Request.service";

const API_URL = {
  API_MANAGE: `/ERP/proforma/manage.php`,
  API_SEARCH: `/ERP/proforma/search.php`,
  API_GETCODE: `/ERP/proforma/get-picode.php`,
  API_RESERVE: `/ERP/proforma/reserve-inv.php`,
  API_PREFILL_INV: `/ERP/proforma/prefill-inv.php`,
  API_AVAILABLE_INV: `/ERP/proforma/available-invoice.php`,
};

const ProformaService = () => {
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (code) => api.delete(`${API_URL.API_MANAGE}?code=${code}`);
  const get = (code) => api.get(`${API_URL.API_MANAGE}?code=${code}`);
  const code = () => api.get(`${API_URL.API_GETCODE}`);

  /* จองเลข Invoice ให้ PI ใบนี้ */
  const reserveInvoice = (pi_code) => api.post(`${API_URL.API_RESERVE}`, { pi_code });
  const cancelReserve = (pi_code) => api.delete(`${API_URL.API_RESERVE}?code=${pi_code}`);

  /* วิธีที่ 2 : ดึงข้อมูลมาจาก Invoice */
  const prefillFromInvoice = (inv_code) =>
    api.get(`${API_URL.API_PREFILL_INV}?code=${encodeURIComponent(inv_code)}`);
  const availableInvoices = (keyword = "") =>
    api.get(`${API_URL.API_AVAILABLE_INV}?keyword=${encodeURIComponent(keyword)}`);

  const search = (parm = {}, config = {}) =>
    api.post(`${API_URL.API_SEARCH}`, parm, { ...config, cancle: true });

  return {
    create,
    update,
    deleted,
    get,
    code,
    reserveInvoice,
    cancelReserve,
    prefillFromInvoice,
    availableInvoices,
    search,
  };
};

export default ProformaService;
